<template>
    <div class="textbook-d aboutus">
        <div ref="navBarRef"><navBar></navBar></div>
        <div class="t-banner" :style="{backgroundImage: 'url(' + bannerUrl + ')'}">
            <div class="pop-box"></div>
        </div>
        <div class="book-content">
            <div class="book-content-item">
                <img class="t-pic" :src="picUrl" alt="">
                <img class="shadow-bot" src="https://restaskimg.civaonline.cn/imagesH5/textbook/pic-shadow.png" alt="">
                <div class="item-intro">
                    <h5 class="intro-title">{{bookDetail.bookInfo.title}}</h5>
                    <div class="use-obj">使用对象：{{bookDetail.bookInfo.useObj}}</div>
                    <p class="intro">课时安排：{{bookDetail.bookInfo.coursePlan}}</p>
                    <p class="intro">配套教辅：{{bookDetail.bookInfo.teaAssistant}}</p>
                    <p class="intro">衔接教材：{{bookDetail.bookInfo.linkMaterial}}</p>
                </div>
            </div>
        </div>
        <!--tab切换-->
        <div :class="['nav-box', tabFixed ? 'isFixed' :'']"  ref="tabsRef">
            <ljTab
                    v-model="selectedId"
                    :items="tabItems"
                    @click.native="changeSelect"
                    :options="options">
            </ljTab>
        </div>
        <div v-if="tabFixed" class="b-tabs"></div>
        <!--教材内容-->
        <div class="t-content" ref="contentRef">
            <div class="t-txt-item">
                <div class="t-item" v-for="(list,index,key) in bookDetail.bookDesc" :key="key">
                    <h5 class="title">{{list.title}}</h5>
                    <p class="intro">{{list.desc}}</p>
                </div>
            </div>
            <div class="t-con-item" ref="examplesRef">
                <h5 class="t-title">教材示例</h5>
                <ul class="h-items">
                    <li class="h-item-img" v-for="(img, index, key) in examplesImg" :key="key" @click="imagePreview(examplesImg,index)">
                        <img :src="img.pic" alt="">
                    </li>
                </ul>
            </div>
            <div class="t-con-item" ref="auxiliaryRef">
                <h5 class="t-title">配套教辅</h5>
                <ul class="h-items" v-if="auxiliaryImg.length>0">
                    <li class="h-item-img" v-for="(img, index, key) in auxiliaryImg" :key="key" @click="imagePreview(auxiliaryImg,index)">
                        <img :src="img.pic" alt="">
                    </li>
                </ul>
            </div>
            <div class="t-con-item" ref="videoRef">
                <h5 class="t-title">配套视频</h5>
                <div class="t-video" @click="videoPlay" :style="{backgroundImage: 'url(' + videoPoster + ')'}"  v-if="bookDetail.videoUrl">
                    <img class="play-btn" src="https://restaskimg.civaonline.cn/imagesH5/product/play-btn.png" alt="" v-if="!videoStatus">
                </div>
            </div>
        </div>
        <!--视频播放弹框-->
        <div class="popup-box" v-show="popupVisible" @click="popupClose">
            <div class="popup">
                <video class="play-video" ref="videoPlay" preload="auto" controls="controls" :poster="videoPoster">
                    <source :src="bookDetail.videoUrl" type="video/mp4">
                </video>
            </div>
        </div>
        <!--图片预览-->
        <div class="popup-box" v-show="imgVisible" @click="imageClose">
            <div class="popup img-popup">
                <div class="img-box">
                    <div class="swiper-container home-swiper" id="img">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(bigPic,index) in imagesList" :key="index">
                                <img class="big-img" :src="bigPic" alt="">
                            </div>
                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ljTab from '@/components/tabs/';
import navBar from '@/components/navBar';
import data from '../../data/detail2';
import Swiper from 'swiper';
export default {
  components: {
    ljTab, navBar,
  },
  data() {
    return {
      selectedId: 0,
      tabItems: [
        {
          name: '教材介绍',
          id: '1',
        },
        {
          name: '教材示例',
          id: '2',
        },
        {
          name: '配套教辅',
          id: '3',
        },
        {
          name: '配套视频',
          id: '4',
        },
      ],
      tabFixed: false,
      options: {
        activeTextColor: '#293340',
        activeColor: '#FF7500',
        labelKey: 'name',
        // 可在这里指定labelKey为你数据里文字对应的字段
      },
      jsonData: data,
      bookDetail: {},
      bannerUrl: '',
      picUrl: '',
      examplesImg: [],
      auxiliaryImg: [],
      videoPoster: '',
      videoStatus: false,
      popupVisible: false,
      imagesList: [],
      imgVisible: false,
      mySwiper: null,
    }
  },
  // created() {
  //   const id = this.$route.query.id;
  //   this.bookDetail = this.jsonData[id];
  //   this.picUrl = 'https://restaskimg.civaonline.cn/imagesH5/textbook/' + this.bookDetail.bookInfo.picUrl + '.png';
  //   this.bannerUrl = 'https://restaskimg.civaonline.cn/imagesH5/textbook/details/' + this.bookDetail.bookInfo.picUrl + '.png';
  //   // console.log(this.bookDetail);
  //   for (let i = 1; i <= 6; i++) {
  //     this.examplesImg.push({
  //       'pic': 'https://restaskimg.civaonline.cn/imagesH5/textbook/small/' + this.bookDetail.imgFolder + '/e' + i + '.png',
  //       'bigPic': 'https://restaskimg.civaonline.cn/imagesH5/textbook/big/' + this.bookDetail.imgFolder + '/e' + i + '.png',
  //     });
  //   }
  //   if (this.bookDetail.imgFolder !== '15' && this.bookDetail.imgFolder !== '16'){
  //     for (let i = 1; i <= 4; i++) {
  //       this.auxiliaryImg.push({
  //         'pic': 'https://restaskimg.civaonline.cn/imagesH5/textbook/small/' + this.bookDetail.imgFolder + '/c' + i + '.png',
  //         'bigPic': 'https://restaskimg.civaonline.cn/imagesH5/textbook/big/' + this.bookDetail.imgFolder + '/c' + i + '.png',
  //       });
  //     }
  //   }
  //   if (this.bookDetail.videoPoster) {
  //     this.videoPoster = 'https://restaskimg.civaonline.cn/imagesH5/textbook/video/' + this.bookDetail.videoPoster + '.png';
  //   }
  // },
  created() {
    this.bookDetail = this.jsonData[this.$route.query.id];
    this.picUrl = this.bookDetail.bookInfo.picUrl ;
    this.bannerUrl = this.bookDetail.bookInfo.bannerUrl;
    this.examplesImg = this.bookDetail.examplesImg;
    this.auxiliaryImg = this.bookDetail.auxiliaryImg;
    this.videoPoster = this.bookDetail.videoPoster;
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    if (this.bookDetail.videoUrl){
      const that = this;
      this.$refs.videoPlay.onended = function() {
        that.videoStatus = false;
      };
    }
  },
  destroyed(){
    window.removeEventListener('scroll', this.handleScroll);// 监听页面滚动事件
  },
  methods: {
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const navBarH = this.$refs.navBarRef.offsetHeight;// nav高度
      const tabH = this.$refs.tabsRef.offsetHeight; // tab高度
      const offsetTop = this.$refs.contentRef.offsetTop; // 教材定位 st
      const examplesH = this.$refs.examplesRef.offsetTop; // 教材示例 st
      const auxiliaryH = this.$refs.auxiliaryRef.offsetTop; // 配套教辅 st
      const videoH = this.$refs.videoRef.offsetTop; // 配套视频 st
      const hei = scrollTop + tabH + navBarH;
      if ( hei + 24 < examplesH) {
        this.selectedId = 0;
      } else if (hei > videoH || hei - 80 >= examplesH) this.selectedId = 3;
      else if (hei < videoH && hei - 60 >= examplesH) this.selectedId = 2;
      else if (hei < auxiliaryH && hei + 24 > examplesH) {
        this.selectedId = 1;
      }
      // else if (hei < videoH && hei > auxiliaryH) {
      //   this.selectedId = 2;
      // } else if (hei > videoH) this.selectedId = 3;
      hei > offsetTop ? this.tabFixed = true : this.tabFixed = false
    },
    changeSelect() {
      this.$nextTick(() => {
        const navBarH = this.$refs.navBarRef.offsetHeight;// nav高度
        const tabH = this.$refs.tabsRef.offsetHeight; // tab高度
        const offsetTop = this.$refs.contentRef.offsetTop; // 教材定位 st
        const examplesH = this.$refs.examplesRef.offsetTop; // 教材示例 st
        // const auxiliaryH = this.$refs.auxiliaryRef.offsetTop; // 配套教辅 st
        // const videoH = this.$refs.videoRef.offsetTop; // 配套视频 st
        // console.log('this.selectedId' + this.selectedId)
        if (this.selectedId === 0) {
          window.scrollTo(0, offsetTop - navBarH - tabH);
        }
        if (this.selectedId === 1) {
          window.scrollTo(0, examplesH - navBarH - tabH);
        }
        if (this.selectedId === 2) {
          window.scrollTo(0, examplesH - navBarH - tabH + 60);
        }
        if (this.selectedId === 3) {
          window.scrollTo(0, examplesH - navBarH - tabH + 80);
        }
      })
    },
    videoPlay() {
      if (!this.videoStatus){
        this.videoStatus = true;
        this.popupVisible = true;
        this.$refs.videoPlay.play();
      }
    },
    popupClose() {
      this.$refs.videoPlay.pause();
      this.videoStatus = false;
      this.popupVisible = false;
    },
    imagePreview(images, index){
      this.$nextTick(() => {
        images.forEach((item) => {
          this.imagesList.push(item.bigPic);
        });
        this.imgVisible = true;
        this.mySwiper = new Swiper('.swiper-container', {
          initialSlide: index,
          pagination: '.swiper-pagination',
          paginationClickable: true,
          // autoHeight: true,
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        });
      });
    },
    imageClose() {
      /* const e = e || window.event; // 浏览器兼容性
      const elem = e.target || e.srcElement;
      while (elem) { // 循环判断至跟节点，防止点击的是div子元素
        if (elem.id && elem.id === 'img'){
          return;
        }
      }*/
      this.imgVisible = false;
      this.imagesList = [];
      this.mySwiper.destroy();
    },
  },
}
</script>

<style scoped lang="less">
.textbook-d{
    .t-banner{
        width: 100%;
        height: 370px;
        background-color: #fff;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        position: relative;
        .pop-box{
            position: absolute;
            width: 100%;
            height: 370px;
            background: rgba(0,0,0,.2);
        }
    }
    .b-tabs{
        width: 100%;
        height: 80px;
    }
    .book-content{
        padding: 0 32px;
        margin : -136px 0 70px;
    }
    .book-content-item{
        width: 100%;
        height: 306px;
        position: relative;
        .t-pic{
            width: 226px;
            position: absolute;
            left: 0;
            /*top: -27px;
            left: 21px;*/
            border-radius: 12px;
            z-index: 1;
        }
        .shadow-bot{
            position: absolute;
            width: 155px;
            bottom: -28px;
            left: 35px;
        }
        .item-intro{
            flex: 1;
            font-family: SyMedium;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 33px;
            margin-left: 256px;
            .intro-title{
                line-height: 50px;
                font-family: SyMedium;
                font-size: 36px;
                color: #FFFFFF;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                width: 100%;
            }
            .use-obj{
                margin: 8px 0 60px;
                height: 64px;
                line-height: 32px;
            }
            .intro{
                margin-top: 14px;
                color: #293340;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
        }
    }
    .nav-box{
        padding-right: 56px;
    }
    .t-content{
        padding-top: 60px;
        padding-bottom: 50px;
        .t-txt-item{
            padding: 0 20px;
            .t-item{
                padding: 0 15px 24px;
                .title{
                    color: #293340;
                    font-size: 28px;
                    font-family: SyMedium;
                }
                .intro{
                    margin-top: 16px;
                    color: #686B75;
                    white-space: pre-wrap;
                    line-height: 42px;
                }
            }
        }
        .t-con-item{
            padding-top: 90px;
            padding-left: 20px;
            .t-title{
                color: #293340;
                line-height: 45px;
                font-size: 32px;
                padding-bottom: 30px;
            }
        }
        .h-items{
            overflow-x: auto;
            white-space:nowrap;
            width: auto;
            .h-item-img{
                width: 190px;
                height: 258px;
                border-radius: 14px;
                margin-right: 24px;
                overflow: hidden;
                display: inline-block;
                img{
                    width: 100%;
                    height: 100%;
                    display: block;
                }
            }
            h-item-img:last-child{
                margin-right: 0;
            }
        }
        .h-items::-webkit-scrollbar {
            display: none;
        }
        .t-video{
            position: relative;
            width: 340px;
            height: 260px;
            background-color: #f4f4f4;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            .play-btn{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 104px;
            }
            .play-video{
                width: 100%;
                height: 468px;
            }
        }
    }
    .popup-box{
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.65);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1001;
        .popup{
            height: 100%;
            width: 100%;
            position: relative;
            .play-video{
                width: 100%;
                height: auto;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
    .img-popup{
        background: #000000;
        .img-box{
            width: 100%;
            height: auto;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            .swiper-container{
                width: 100%;
                height: auto;
                overflow: visible;
                .big-img{
                    width: 100%;
                }
            }
            .swiper-container-horizontal > .swiper-pagination-bullets{
                bottom: -134px;
                display: flex;
                height: 134px;
                align-items: center;
                justify-content: center;
            }
        }
    }
}
</style>
